<template>
    <div>
        <section class="search-list" v-for="(project, index) in getListToRender()" :key="index">
            <span class="new" v-if="project.new_flg === 1"><span>NEW</span></span>

            <div class="search-list__inner">
                <div class="pc_link js_pc_link">
                    <div class="search-list__01">
                        <h3>
                            <a :href="'/project/' + project.project_id">
                                <span>{{ project.project_name }}</span>
                            </a>
                        </h3>
                    </div>
                    <!-- 金額その他 -->
                    <div class="search-list__02">
                        <ul>
                            <li class="search-list__yen">〜<span>{{ Number( calcFlPrice(project.project_price, project.contract_type) ).toLocaleString() }}</span>円/月</li>
                            <li class="search-list__area">{{ selectAreaName(project) }}</li>
                            <li class="search-list__tag">
                                <template v-for="(condition_type, index) in shapeConditionTypeNames(project.condition_type_ids)">
                                    <span class="tag" :key="index" v-if="condition_type">{{ condition_type }}</span>
                                </template>
                            </li>
                        </ul>
                    </div>
                    <div
                        :class="[showToggle(project.project_id) ? 'is-open' : ''] + ' search_acd__list'"
                        :style="showToggle(project.project_id) ? getClientHight(project.project_id) : resetClientHight()">
                        <div class="search_acd__list__innner" :ref="'inner' + project.project_id">
                            <!-- 募集要項 -->
                            <div class="search-list__youkou ">
                                <div class="dl_left">
                                    <dl>
                                        <!-- 職種 -->
                                        <dt>職種</dt>
                                        <dd>{{ project.job_type_name }}</dd>
                                    </dl>
                                    <dl>
                                        <!-- 業界 -->
                                        <dt>業界</dt>
                                        <dd>{{ project.industry_type_name }}</dd>
                                    </dl>
                                    <dl>
                                        <!-- 技術 -->
                                        <dt>スキル</dt>
                                        <dd>{{ shapeSkillNames(project.skill_ids) }}</dd>
                                    </dl>
                                </div>
                                <div>
                                    <dl class="dl_right">
                                        <!-- 必須スキル -->
                                        <dt>必須スキル</dt>
                                        <dd>
                                            <p v-html="nl2br(project.required_skills)"></p>
                                        </dd>
                                    </dl>
                                </div>
                            </div>
                            <!-- おすすめポイント -->
                            <div class="search-list__osusume">
                                <h4>おすすめポイント</h4>
                                <p v-html="nl2br(project.recommended_points)"></p>
                            </div>
                        </div>
                    </div>
                    <span :class="[showToggle(project.project_id) ? 'is-active' : ''] + ' search_acd'" v-on:click="onDetailToggle(project.project_id)"></span>
                </div>
                <!-- 下部ボタン -->
                <div class="search-list__button">
                    <input type="checkbox"
                        :name="'favo_button_' + project.project_id"
                        :id="'favo_button_' + project.project_id"
                        :value="project.project_id"
                        :checked="checkFavorite(project.project_id)"
                        v-on:change="onFavorite(project.project_id)"
                    >
                    <label :for="'favo_button_' + project.project_id" class="favo_button"></label>

                    <div>
                        <div class="simple_button">
                            <a class="single_button" :href="'/entry/' + project.project_id">案件の詳細を聞く</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import cookie from '../../util/cookie';
    import nl2br from '../../util/nl2br';
    import pcLink from '../../util/pcLink';
    import JSONbig from 'json-bigint';

    export default {
        props: {
            projects: Object,
            cookie_expires: Number,
            max_favorite_count: Number,
            price_adjustments: Object,  // フリーランス単価調整率
            contract_types: Object,    // 契約形態コード
            condition_types: Array,
            skill_types: Array,
            projects_flg: Boolean
        },

        data() {
            return {
                project_list: [],
                favorites_cookie: [],
                skills_data: [],
                show_details: [],
                toggle_project_ids : []
            }
        },

        created() {
            // お気に入りのクッキーを取得
            if (cookie.hasCookie('favorites')) {
                const cookies = cookie.getCookie('favorites');

                // cookieを配列化、整数以外を除外し、中のproject_idを文字列からbigintに変換
                if (cookies) {
                    this.favorites_cookie = this.shapeCookies(cookies);
                }
            }

            // スキルだけの配列を作成
            this.skill_types.forEach((skill_type) => {
                this.skills_data = this.skills_data.concat(skill_type.skills);
            });
        },

        mounted() {
            // デザインに関するjsの読み込み
            pcLink();

            // 幅が751px～800pxの場合は、トグルを全開
            this.setToggleClientHight();
        },

        methods: {
            // フリーランス単価調整計算
            calcFlPrice: function(project_price, contract_type) {
                let adjustment_price = project_price;
                let rate = this.price_adjustments['freelance_rate'];
                if (contract_type == this.contract_types['temping']) {
                    rate = this.price_adjustments['temporary_rate'];
                }

                if (contract_type == this.contract_types['service_consignment'] ||
                    contract_type == this.contract_types['temping']) {
                    adjustment_price = project_price - Math.floor(project_price * rate);
                    if (adjustment_price > 9999) {
                        let temp_price = Math.floor(adjustment_price / 10000);
                        adjustment_price = temp_price * 10000;
                    }
                }
                return adjustment_price;
            },

            // トグルの高さのセット
            setToggleClientHight()
            {
                // 幅が750px～799pxの場合は、トグルを全開（タブレット）
                if (window.innerWidth < 800 && window.innerWidth >= 750) {
                    this.toggle_project_ids = this.projects.map((project) => project.project_id);
                // 幅が750px未満の場合は、トグルをリセット
                } else if (window.innerWidth < 750) {
                    this.toggle_project_ids = [];
                }
            },

            // トグル時の詳細表示の高さを取得
            getClientHight: function(project_id)
            {
                if (window.innerWidth < 800) {
                    const inner = this.$refs['inner' + project_id];
                    let inner_hight = 0;
                    if (inner.length > 0) {
                        inner_hight = inner[0].clientHeight + 50;
                        return `height: ${inner_hight}px`
                    }
                    return '';
                }
            },

            // トグル時の詳細表示の高さをリセット
            resetClientHight: function()
            {
                return window.innerWidth < 800 ? 'height: 0px' : '';
            },

            // トグルを表示
            showToggle: function(project_id)
            {
                return this.toggle_project_ids.includes(project_id);
            },

            // トグルのクリック時の挙動
            onDetailToggle: function(project_id)
            {
                if (!this.toggle_project_ids.includes(project_id)) {
                    this.toggle_project_ids.push(project_id);
                } else {
                    this.toggle_project_ids = this.toggle_project_ids.filter(id => String(id) != String(project_id)); // bigint比較のため、値を文字列に変換
                }
            },

            // 各こだわり案件名を取得
            shapeConditionTypeNames: function(condition_type_ids)
            {
                if (condition_type_ids) {
                    const condition_type_names = condition_type_ids.split(',').map((condition_type_id) => {

                        const condition_types = this.condition_types.filter((condition_type) => condition_type.condition_type_id == condition_type_id)
                        if(condition_types.length > 0) {
                            return condition_types[0].condition_type_name;
                        }
                    });
                    return condition_type_names ? condition_type_names : [];
                }
            },

            // 各スキル名を取得
            shapeSkillNames: function(skill_ids)
            {
                if (skill_ids) {
                    const skill_names = skill_ids.split(',').map((skill_id) => {
                        const skills = this.skills_data.filter((skill) => skill.skill_id == skill_id);
                        if(skills.length > 0) {
                            return skills[0].skill_name;
                        }
                    });

                    return skill_names ? skill_names.join(',') : [];
                }
            },

            // サブエリアがなければ、エリア->都道府県の順番に表示する
            selectAreaName: function(project)
            {
                if (project.sub_area_name) {
                    return project.sub_area_name;
                }

                if (project.area_name) {
                    return project.area_name;
                }

                return project.prefecture_name;
            },

            // cookieを配列化、整数以外を除外し、中のproject_idを文字列からbigintに変換
            shapeCookies: function(cookies) {
                return cookies.split('%2C').flatMap((favorite_id) => {
                    if (favorite_id.match(/^[1-9][0-9]*$/)) {
                        return JSONbig.parse(favorite_id);
                    }
                })
            },

            // お気に入りボタンのチェック
            checkFavorite: function(project_id)
            {
                if (this.favorites_cookie) {
                    // bigint比較のため、値を文字列に変換
                    return this.favorites_cookie.some((favorite_id) => String(favorite_id) === String(project_id)) ? true : false;
                }
                return false;
            },

            // お気に入りボタンの有効・無効
            onFavorite: function(project_id)
            {
                if (cookie.hasCookie('favorites')) {
                    this.setFavoritesCookie('favorites', project_id, 60 * 60 * 24 * this.cookie_expires, this.max_favorite_count);
                } else {
                    cookie.setCookie('favorites', project_id, 60 * 60 * 24 * this.cookie_expires);
                    this.favorites_cookie.unshift(project_id);
                    this.addHeaderFavoriteCount();
                }
            },

            // 配列を、,で区切り文字列としてセット
            setFavoritesCookie: function(key, val, expire, max_count)
            {
                let arr = [];

                // 文字列から配列に変換
                const cookies = cookie.getCookie(key);

                if (cookies) {
                    // cookieを配列化、整数以外を除外し、中のproject_idを文字列からbigintに変換
                    arr = this.shapeCookies(cookies);
                }

                // すでに値が存在すれば値を削除、無ければ値を追加
                if (arr.some((item) => String(item) === String(val))) { // bigint比較のため、値を文字列に変換
                    arr = arr.filter(item => String(item) != String(val)); // bigint比較のため、値を文字列に変換
                    this.subHeaderFavoriteCount();
                    this.favorites_cookie = this.favorites_cookie.filter(item => item != val);
                } else {
                    arr.unshift(val);
                    this.addHeaderFavoriteCount();
                    this.favorites_cookie.unshift(val);
                }

                // 最大数を超えていれば、最初のひとつを削除
                if (arr.length > max_count) {
                    arr.splice(-1, 1);
                    this.favorites_cookie.splice(-1, 1);
                }

                cookie.setCookie(key, arr.join('%2C'), expire);
            },

            // ヘッダーのお気に入りのカウントを増やす
            addHeaderFavoriteCount: function()
            {
                // カウントのspan要素が存在する場合は、増やす
                if (document.getElementById('pc_favorite_count')) {
                    const current_count = Number(document.getElementById('pc_favorite_count').innerHTML);

                    if (current_count < this.max_favorite_count) {
                        document.getElementById('pc_favorite_count').innerHTML = current_count + 1;
                        document.getElementById('sp_favorite_count').innerHTML = current_count + 1;
                        document.getElementById('sp_favorite_count_header').innerHTML = current_count + 1;
                    }
                // カウントのspan要素が存在しない場合は、span要素を作成
                } else {
                    let pc_span = document.createElement('span');
                    pc_span.id = "pc_favorite_count"
                    pc_span.textContent = 1;
                    let mobile_span = document.createElement('span');
                    mobile_span.id = "sp_favorite_count"
                    mobile_span.textContent = 1;
                    let mobile_span_header = document.createElement('span');
                    mobile_span_header.id = "sp_favorite_count_header"
                    mobile_span_header.textContent = 1;
                    mobile_span_header.classList.add("count_batch");
                    document.getElementById('pc_favorite_counter').appendChild(pc_span);
                    document.getElementById('sp_favorite_counter').appendChild(mobile_span);
                    document.getElementById('sp_favorite_counter_header').appendChild(mobile_span_header);
                }
            },

            // ヘッダーのお気に入りのカウントを減らす
            subHeaderFavoriteCount: function()
            {
                // カウントが1の場合は、span要素を削除
                if (document.getElementById('pc_favorite_count').innerHTML == 1) {
                    const current_pc_span = document.getElementById('pc_favorite_count');
                    const current_mobile_span = document.getElementById('sp_favorite_count');
                    const current_mobile_span_header = document.getElementById('sp_favorite_count_header');
                    document.getElementById('pc_favorite_counter').removeChild(current_pc_span);
                    document.getElementById('sp_favorite_counter').removeChild(current_mobile_span);
                    document.getElementById('sp_favorite_counter_header').removeChild(current_mobile_span_header);
                // カウントが2以上の場合は、減らす
                } else {
                    const current_count = Number(document.getElementById('pc_favorite_count').innerHTML);
                    document.getElementById('pc_favorite_count').innerHTML = current_count - 1;// PC
                    document.getElementById('sp_favorite_count').innerHTML = current_count - 1;// mobile
                    document.getElementById('sp_favorite_count_header').innerHTML = current_count - 1;// mobile
                }
            },

            // 案件検索とお気に入りで表示方法を変える
            getListToRender() {
                // projects_flg が TRUE の場合は 案件一覧 を返し、FALSE の場合は お気に入り を返す
                return this.projects_flg ? this.projects.data : this.projects;
            },

            nl2br: nl2br,
        }
    }
</script>
